import React from 'react'
import { PageAdditionalProps } from 'page-lifecycle-provider'

import {
    PublicationRouteProps,
    GalleryPublicationInformation,
    getPublicationInfoFromRouteResolution,
} from 'component-library/templates/Publication/SharedPublication.routing'
import { createRegisterableComponent } from 'common/routing/page-definition'
import { TheWestGallery } from './TheWestGallery'
import { getPublicationPageProperties } from '../lib/publication-page-properties'

export const TheWestGalleryRegistration = createRegisterableComponent(
    'gallery',
    (props: PublicationRouteProps, services) => {
        const publicationInfo = getPublicationInfoFromRouteResolution(services)
        if (publicationInfo.publication.kind !== 'gallery') {
            throw new Error('Gallery component rendered for non-gallery')
        }

        const galleryMeta = props.meta as GalleryPublicationInformation
        return (
            <PageAdditionalProps
                pageProperties={getPublicationPageProperties(publicationInfo.publication)}
            >
                <TheWestGallery
                    adState={services.adState}
                    gallery={publicationInfo.publication}
                    galleryMeta={galleryMeta}
                    location={services.location}
                    onEvent={services.onEvent}
                />
            </PageAdditionalProps>
        )
    }
)
